import { SubmitButton, TextInput } from "../../hook-form";
import {
  ModalContainer,
  SectionHeader,
  ToastNotification,
} from "../../components";
import { IHookForm, IChangePasswordRequest } from "../../interfaces-and-types";

export const View = ({
  isModalOpen,
  closeModal,
  passwordResetSuccessful,
  redirectToLogin,
  handleSubmit,
  register,
  errors,
}: IHookForm<IChangePasswordRequest> & {
  isModalOpen: boolean;
  closeModal: () => void;
  passwordResetSuccessful: boolean;
  redirectToLogin: () => void;
  // mismatchErrorMessage: string | null;
}) => {
  return (
    <ModalContainer
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      modalHeader={
        <SectionHeader
          title="Change Password"
          subtitle="Change your login password."
        />
      }
    >
      <form onSubmit={handleSubmit}>
        <div className="flex-container col justify-content--center align-items--center">
          <div style={{ minWidth: "50%", maxWidth: 800 }}>
            <div className="form-container__body">
              <div className="form-container__body__input-container">
                <TextInput
                  name="current_password"
                  label="Current Password"
                  type="password"
                  register={register}
                  errors={errors}
                />
              </div>

              <div className="form-container__body__input-container">
                <TextInput
                  name="new_password"
                  label="New Password"
                  type="password"
                  register={register}
                  errors={errors}
                />
              </div>

              <div className="form-container__body__input-container">
                <TextInput
                  name="new_password_confirmation"
                  label="Confirm New Password"
                  type="password"
                  register={register}
                  errors={errors}
                />
              </div>
            </div>

            <div className="flex-container mt-5">
              <SubmitButton className=" mt-5 align-self--stretch">
                Save Changes
              </SubmitButton>
            </div>
          </div>
        </div>
      </form>
    </ModalContainer>
  );
};
